import { render, staticRenderFns } from "./All.vue?vue&type=template&id=33addb49&scoped=true"
import script from "./All.vue?vue&type=script&lang=js"
export * from "./All.vue?vue&type=script&lang=js"
import style0 from "./All.vue?vue&type=style&index=0&id=33addb49&lang=scss&scoped=true"
import style1 from "./All.vue?vue&type=style&index=1&id=33addb49&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33addb49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33addb49')) {
      api.createRecord('33addb49', component.options)
    } else {
      api.reload('33addb49', component.options)
    }
    module.hot.accept("./All.vue?vue&type=template&id=33addb49&scoped=true", function () {
      api.rerender('33addb49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/All.vue"
export default component.exports